import { useRecoilValue } from "recoil";
import { billingAtom } from "../store/billingAtom";
import { InformationCircleIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";
import { format } from "date-fns";

const PlanCancelAlert = () => {
  const [show, setShow] = useState(false);

  const billingInfo = useRecoilValue(billingAtom);
  const active_plan = billingInfo?.active_plan?.payment_plan
  const next_plan = billingInfo?.next_plan?.payment_plan


  useEffect(() => {
    setShow(Boolean(next_plan && next_plan?.id !== active_plan?.id));
  }, [billingInfo]);

  if (!show) return null;

  return (
    <div className="border shadow rounded-xl p-4 border-gray-300 flex justify-between items-start gap-6 w-full text-sm sm:text-base/7">
      <div className="flex items-start gap-6">
        <InformationCircleIcon className="min-w-6 size-6 text-red-600" />
        <div>
          <p className="font-semibold p-0 m-0 mb-1 text-gray-700">
            Your {active_plan?.name} Plan was canceled
          </p>
          {Boolean(billingInfo?.next_plan?.plan_start_date) && (
            <p className="p-0 m-0 text-gray-600">
              Your account will update to the {next_plan?.name}{" "}
              Plan on{" "}
              {format(billingInfo?.next_plan?.plan_start_date, "M/d/yy")}
            </p>
          )}
        </div>
      </div>

      <button type="button" onClick={() => setShow(false)}>
        <XMarkIcon className="size-6 text-gray-500 hover:text-gray-600" />
      </button>
    </div>
  );
};

export default PlanCancelAlert;
